import localforage from "localforage";

// create a new instance of localforage with a custom name for indexeddb
const db = localforage.createInstance({
  name: "goalsDB",
  driver: localforage.INDEXEDDB,
  storeName: "goalsStore",
  version: 1.0,
});

export default db;
